import { Component, Input } from '@angular/core';
import {CqCicloControllo} from "../../../_models/CqCicloControllo";

@Component({
    selector: 'app-controllo-qualita-item',
    templateUrl: './controllo-qualita-item.component.html',
    styleUrls: ['./controllo-qualita-item.component.scss'],
    standalone: false
})
export class ControlloQualitaItemComponent  {
  @Input() cicloControllo: CqCicloControllo;
}
